<template>
  <div class="editAddress">
    <van-form @submit="onSubmit" label-width="120px">
      <van-field
        v-model="form.ReceivingName"
        :label="$t.address.receivingName"
        :placeholder="$t.meta.input"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.input + ' ' + $t.address.receivingName,
          },
        ]"
      />

      <van-field
        v-model="form.PhoneNumber"
        :label="$t.address.phoneNumber"
        :placeholder="$t.meta.input"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.input + ' ' + $t.address.phoneNumber,
          },
        ]"
      />

      <van-field
        v-model="form.PostalCode"
        :label="$t.address.postcode"
        :placeholder="$t.meta.input"
      />

      <van-field
        readonly
        clickable
        :value="country.text"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowCountry"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.select + ' ' + $t.meta.country,
          },
        ]"
      />
      <van-field
        readonly
        clickable
        :value="city.text"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowCity"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.select + ' ' + $t.meta.city,
          },
        ]"
      />

      <van-field
        v-model="form.ReceivingAddress"
        :label="$t.address.receivingAddress"
        :placeholder="$t.meta.input"
        type="textarea"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.select + ' ' + $t.address.receivingAddress,
          },
        ]"
      />

      <van-field :label="$t.address.isDefault">
        <template #input>
          <van-switch v-model="form.IsDefult" size="20" />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>

      <div style="margin: 16px" v-if="isEdit && !isSelection">
        <van-button round block type="danger" @click="onDelete" native-type="button">{{
          $t.meta.delete
        }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showAddressCountrys"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showAddressCities"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Switch } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Switch);
export default {
  name: "editAddress",
  props: {
    addressData: {
      type: Object,
      default: null,
    },
    isSelection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OptionList,
  },
  data() {
    return {
      isEdit: false,
      countryList: [],
      country: {
        text: "",
        value: "",
      },
      cityList: [],
      city: { text: "", value: "" },
      form: {
        CRId: null,
        ReceivingName: "",
        PhoneNumber: "",
        PostalCode: "",
        CountryId: null,
        CityId: null,
        ReceivingAddress: "",
        IsDefult: false,
      },
    };
  },
  created() {
    if (this.isSelection) {
      if (this.addressData) {
        this.form = this.addressData;
        this.applyData(this.addressData);
      }
      this.getOptions();
    } else {
      const query = this.$route.query;
      if (query.Address) {
        this.isEdit = true;
        this.form = query.Address;
        this.applyData(query.Address);
      }
      this.getOptions();
    }
  },
  methods: {
    applyData(data) {
      this.country.text = data.CountryName;
      this.city.text = data.CityName;
      if (data.IsDefult == 1) {
        this.form.IsDefult = true;
      } else {
        this.form.IsDefult = false;
      }
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountryList(), this.getCityList()]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onShowCountry() {
      this.$bus.$emit("showAddressCountrys", true);
    },
    onSelectCountry(item) {
      this.country.text = item.text;
      this.country.value = item.value;
      this.form.CountryId = item.value;
    },
    onShowCity() {
      this.$bus.$emit("showAddressCities", true);
    },
    onSelectCity(item) {
      this.city.text = item.text;
      this.city.value = item.value;
      this.form.CityId = item.value;
    },
    getCountryList() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList(param)
          .then((res) => {
            this.formatCountry(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCountry(countrys) {
      countrys.forEach((item) => {
        let country = {
          text: item.CountryName,
          value: item.CountryId,
        };
        this.countryList.push(country);
      });
    },
    getCityList() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList(param)
          .then((res) => {
            this.formatCity(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCity(cities) {
      cities.forEach((item) => {
        let city = {
          text: item.City_cn,
          value: item.Id,
        };
        this.cityList.push(city);
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      if (this.form.IsDefult) {
        param.IsDefult = 1;
      } else {
        param.IsDefult = 0;
      }
      var request = null;
      if (this.isEdit || this.addressData) {
        request = this.$api.address.editCustomerReceiving(param);
      } else {
        request = this.$api.address.addCustomerReceiving(param);
      }
      request
        .then((res) => {
          if (this.isSelection) {
            this.$emit("addressDidChanged");
          } else {
            this.$commonMethod.dialogAlert(
              res.message ? res.message : res.Message,
              () => {
                this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
              }
            );
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onDelete() {
      this.$commonMethod.showLoading();
      let param = {
        CRId: this.form.CRId,
      };
      this.$api.address
        .deleteCustomerReceiving(param)
        .then((res) => {
          if (this.isSelection) {
            this.$emit("addressDidChanged");
          } else {
            this.$commonMethod.dialogAlert(
              res.message ? res.message : res.Message,
              () => {
                this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
              }
            );
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.editAddress {
}
</style>
